import "./CouponsAndDiscounts.scss";

import { BasePage } from '@Tenants/Hc/Site/BasePage';
import { BaseCouponsAndDiscounts } from '@Base/CouponsAndDiscounts/CouponsAndDiscounts';

export class CouponsAndDiscounts extends BaseCouponsAndDiscounts
{
	constructor()
	{
		super();
	}

	public Initialize(): void
	{
		this.SiteCoupons = [
			{
				Type: "subscribe",
				MobileCreativeID: "1143602",
				DesktopCreativeID: "1143604",
				SignUpSource: "HCUSPopup",
				ButtonSelector: ".subscribe-js"
			},
			{
				Type: "military",
				MobileCreativeID: "143726",
				DesktopCreativeID: "143724",
				SignUpSource: "HCUSMilitary",
				ButtonSelector: ".military-js"
			},
			{
				Type: "student",
				MobileCreativeID: "143736",
				DesktopCreativeID: "143734",
				SignUpSource: "HCUSStudent",
				ButtonSelector: ".student-js"
			}
		];

		super.Initialize();
	}
}

export class CouponsAndDiscountsPage extends BasePage
{
	public CouponsAndDiscounts: CouponsAndDiscounts;

	constructor()
	{
		super();
		this.Initialize();
	}

	public async Initialize(): Promise<void>
	{
		super.Initialize();
		this.CouponsAndDiscounts = new CouponsAndDiscounts();
	}
}

const couponsAndDiscounts = new CouponsAndDiscountsPage();